export default __webpack_public_path__ + "static-front/media/avatar.3c94f6fe.svg";